/* ═══════════════════════════════════════════════════
   NV – Pulsante «Richiedi la cittadinanza» (snippets/nv-header-cta.liquid)

   Il link funziona anche senza questo file: porta alla tessera della
   Modulistica, che gestisce da sé l'arrivo con l'ancora (script in
   sections/nv-moduli.liquid). Qui c'è solo il clic fatto quando si è già
   sulla pagina del link, che altrimenti non farebbe niente di visibile:
   - se il clic arriva dal menu del telefono aperto, prima lo si chiude e si
     aspetta che sia chiuso davvero: header-drawer.js toglie [open] solo a fine
     animazione (circa 200ms) e lo sblocco dello scorrimento arriva subito
     dopo, con l'evento toggle;
   - poi l'ancora riceve l'evento nv:vai (la tessera lo usa per aprire i
     passaggi «Come si presenta»), si scorre fino a lei, dolcemente tranne con
     movimento ridotto, e le si dà il focus senza farla scorrere di nuovo.

   Un solo ascoltatore delegato su document, protetto da window.nvHctaReady:
   il tema rifonde l'header dopo il caricamento e i nodi cambiano.
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.nvHctaReady) return;
  window.nvHctaReady = true;

  var movimentoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Chiama fatto() quando il cassetto non ha più [open]. Il tetto di 1s evita
     di restare in attesa se l'animazione non finisce (scheda in background). */
  function quandoChiuso(cassetto, fatto) {
    var inizio = performance.now();

    (function controlla() {
      if (!cassetto.hasAttribute('open') || performance.now() - inizio > 1000) {
        setTimeout(fatto, 0);
        return;
      }
      requestAnimationFrame(controlla);
    })();
  }

  function vai(ancora) {
    ancora.dispatchEvent(new CustomEvent('nv:vai', { bubbles: true }));

    if (movimentoRidotto.matches) {
      /* behavior 'auto' seguirebbe lo scroll-behavior: smooth di base.css:
         per il salto secco lo si spegne solo per questa chiamata. */
      var html = document.documentElement;
      var prima = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      ancora.scrollIntoView({ block: 'start' });
      html.style.scrollBehavior = prima;
    } else {
      ancora.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* La tessera ha già tabindex="-1"; un'altra ancora scelta nell'editor
       potrebbe non averlo e senza non riceverebbe il focus. */
    if (!ancora.hasAttribute('tabindex') && ancora.tabIndex < 0) ancora.setAttribute('tabindex', '-1');
    ancora.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target instanceof Element ? event.target.closest('a[data-nv-hcta]') : null;
    if (!link) return;

    /* Solo stessa pagina e con un'ancora che esiste: in ogni altro caso il
       link fa il suo lavoro normale. */
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash.length < 2) return;

    var ancora = null;
    try {
      ancora = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch (errore) {
      return;
    }
    if (!ancora) return;

    event.preventDefault();
    history.replaceState(history.state, '', url.hash);

    var cassetto = link.closest('details.menu-drawer-container');
    if (cassetto && cassetto.hasAttribute('open')) {
      var drawer = cassetto.closest('header-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      else cassetto.removeAttribute('open');
      quandoChiuso(cassetto, function () {
        vai(ancora);
      });
    } else {
      vai(ancora);
    }
  });
})();
